export default __webpack_public_path__ + "static/media/fruit_melon.ecebb4b7.png";